
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2c-2.448 0-4.828.902-6.683 2.433l-2.25-2.25A.625.625 0 002 2.625v5.417c0 .345.28.625.625.625h5.417A.625.625 0 008.483 7.6L6.501 5.617C8.04 4.389 9.99 3.667 12 3.667c4.595 0 8.333 3.738 8.333 8.333 0 4.595-3.738 8.334-8.333 8.334a8.276 8.276 0 01-5.89-2.443.832.832 0 10-1.18 1.178A9.931 9.931 0 0012 22c5.514 0 10-4.486 10-10S17.514 2 12 2z","fill":"#131313"}})])
          )
        }
      }
    